module.exports = __webpack_public_path__ + "img/Terms-o.1e9595c3.svg";